import { addTranslation } from '@shared/lib'

import {en} from './en'
import {ru} from './ru'

export {en, ru}

export const I18N_NAMESPACE = 'datePicker'

addTranslation(I18N_NAMESPACE, {en, ru})